import { ChangeDetectorRef, Component, OnInit, OnDestroy, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import {
  CtBinaryOperator,
  CtButtonConfiguration,
  CTDynamicFormGeneratorComponent,
  CtDynamicFormGeneratorConfiguration,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelRouteData, CtModelService,
  CtModelType,
  MAT_RAISED_PRIMARY,
} from "@ctsolution/ct-framework";
import { WorkOrderRouteData } from "../../../../_core/route-data/work-order.route-data";
import { CTWorkOrder } from "../../../../_core/classes/ct-work-order";
import { GeneralDataComponent } from "./general-data/general-data.component";
import { CTMWorkOrderViewType } from "../../../../_core/enum/work-order-type";
import { WorkOrderService } from "../../work-order.service";
import { GeneralDataConfiguration } from "./general-data/general-data.configuration";
import { MovementManagerComponent } from "./movement-manager/movement-manager.component";
import { CtManagerService } from "../../../../_core/lib/ct-manager.service";
import { CtWebapiGenericResponse, CtWebapiService, DataRequest, MethodEnum } from "@ctsolution/ct-webapi";
import { CTWorkOrderRow } from "../../../../_core/classes/ct-work-order.row";
import { CtWorkOrderInformationContent } from "../../../../_core/classes/ct-work-order.information-content";
import { CTWorkOrderRowUnionType } from "../../../../_core/classes/ct-work-order.row-union";
import { MovementManagerConfiguration } from "./movement-manager/movement-manager.configuration";
import { WorkOrderHandlingsConfiguration } from "./work-order-handlings/work-order-handlings.configuration";
import { WorkOrderDocumentsConfiguration } from './work-order-documents/work-order-documents.configuration';
import { TranslateService } from "@ngx-translate/core";
import { LangDownloadFileConfiguration, WorkOrderRowsExportTypeVO } from '../../../lang-download-file/lang-download-file.configuration';
import { WorkOrderDownloadMenuConfiguration } from '../../../work-order-download-menu/work-order-download-menu.configuration';
import { ReportDownloadParameter } from 'projects/ct-manager/src/app/_core/classes/report-download.parameter';
import { PackagingService } from '../../work-order-packaging/work-order-packaging/work-order-packaging.service';
import { WorkOrderLocationConfiguration } from './work-order-location/work-order-location.configuration';
import { SchedulerListConfiguration } from '../../../scheduler/scheduler-list/scheduler-list.configuration';
import { SchedulerService } from '../../../scheduler/scheduler.service';
import { WorkOrderPackagingConfiguration } from '../../work-order-packaging/work-order-packaging/work-order-packaging.configuration';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { WorkOrderEditTemplateComponent } from './work-order-edit-template/work-order-edit-template.component';
import { WorkOrderEditTemplateConfiguration } from './work-order-edit-template/work-order-edit-template.configuration';
import { WorkOrderDynamicFormService } from './work-order-dynamic-form.service';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { WorkOrderDynamicFormDataParameter } from './work-order-dynamic-form/work-order-dynamic-form.component';
import { ReportController } from 'projects/ct-manager/src/app/_core/controllers/report.controller';
import { CtFileManagementService } from '@ctsolution/ct-file-management';
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { WorkOrderQuotationDialogComponent, WorkOrderQuotationDialogResult } from './work-order-quotation-dialog/work-order-quotation-dialog.component';
import { WorkOrderEventLogDialogComponent, WorkOrderEventLogDialogData } from './work-order-event-log-dialog/work-order-event-log-dialog.component';
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";


@Component({
  selector: 'app-work-order-default-edit',
  templateUrl: `./work-order-default-edit.component.html`,
  styleUrls: [`./work-order-default-edit.component.scss`],
  providers: [{ provide: MatDialogRef, useValue: {} }]
})
export class WorkOrderDefaultEditComponent implements OnInit, OnDestroy {

  // ========================================================================
  // GESTIONE LIFECYCLE E STATO
  // ========================================================================

  /** Subject per gestire la distruzione del componente e prevenire memory leak */
  private destroy$ = new Subject<void>();

  /** Flag per indicare che il componente sta caricando - utile per mostrare spinner */
  isLoading = true;

  // ========================================================================
  // PROPRIETÀ BASE
  // ========================================================================

  pId: string | null = null;
  configuration: CtModelConfiguration<WorkOrderDefaultEditComponent> | null = null;
  existingData: WorkOrderDynamicFormDataParameter | null = null;

  // ========================================================================
  // VIEW CHILDREN
  // ========================================================================

  @ViewChild("headerActions") headerActions: TemplateRef<any> | null = null;
  @ViewChild("EDITOR") editor?: WorkOrderEditTemplateComponent;
  @ViewChild('generalDataComponent') generalDataComponent: GeneralDataComponent | null = null;
  @ViewChild('movementManagerComponent') movementManagerComponent: MovementManagerComponent | null = null;
  @ViewChildren('formGenerator') formGeneratorComponents: QueryList<CTDynamicFormGeneratorComponent> | null = null;

  // ========================================================================
  // CONFIGURAZIONI BOTTONI
  // ========================================================================

  downloadDynamicFormPdf: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("Download pdf")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setIcon("download");

  downloadDynamicFormExcel: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("Download excel")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setIcon("download");

  eventLogButtonConfiguration: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("Log Eventi")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setIcon("history")
    .setAction(() => this.openEventLogDialog())
    .setVisible(false);

  creaPackagingButtonConfiguration: CtButtonConfiguration | null = null;

  // ========================================================================
  // VIEW MODEL
  // ========================================================================

  viewModel: WorkOrderDefaultEditViewModel = {
    workOrder: null,
    workOrderViewType: CTMWorkOrderViewType.Standard,
    workOrderRowHandlingEnabled: false,
    workOrderExtraDataEnabled: false,
    workOrderCalendarEnabled: false,
    selectedIndex: 0,
    masterDetail: false,
    offerEnabled: false,
  };

  // ========================================================================
  // CONFIGURAZIONI DOWNLOAD
  // ========================================================================

  // Disponibilita' del download PDF nel dettaglio, dichiarata per-client nel MenuJson.
  workOrderDownloadConfiguration: CTConfigurationModel = CTConfigurationModel.create();

  langDownloadFileConfiguration: LangDownloadFileConfiguration = LangDownloadFileConfiguration
    .create()
    .setColor("accent")
    .setIcon("picture_as_pdf")
    .setButtonType('mat-mini-fab')
    .setLanguage([{ language: "Italiano", code: "it", type: "IT", icon: "it" }]);

  workOrderDownloadMenuConfiguration: WorkOrderDownloadMenuConfiguration = WorkOrderDownloadMenuConfiguration
    .create()
    .setEnabled(false)
    .setMaxDocumentsToShow(5)
    .setColor("accent")
    .setIcon("picture_as_pdf")
    .setButtonType('mat-mini-fab')
    .setGeneratedPdfLabel("PDF Generato")
    .setUploadedDocumentsLabel("Documenti Caricati")
    .setShowFileIcon(true)
    .setLanguages([{ language: "Italiano", code: "it", type: "IT", icon: "it" }]);

  // ========================================================================
  // CONFIGURAZIONI SEZIONI
  // ========================================================================

  generalDataConfiguration: GeneralDataConfiguration | null = null;
  movementManagerConfiguration: MovementManagerConfiguration | null = null;
  workOrderHandlingsConfiguration: WorkOrderHandlingsConfiguration | null = null;
  workOrderDocumentsConfiguration: WorkOrderDocumentsConfiguration | null = null;
  workOrderLocationConfiguration: WorkOrderLocationConfiguration | null = null;
  workOrderEditTemplateConfiguration: WorkOrderEditTemplateConfiguration | null = null;
  workOrderDynamicTabFormConfiguration: WorkOrderDynamicTabFormConfiguration | null = null;
  workOrderTaskTabConfiguration: CTConfigurationModel | null = null;
  workOrderPaymentTabConfiguration: CTConfigurationModel | null = null;
  schedulerListConfiguration: SchedulerListConfiguration | null = null;
  workOrderSummaryConfiguration: CTConfigurationModel | null = null;

  // ========================================================================
  // GETTER
  // ========================================================================

  get isQuotation(): boolean {
    return this.viewModel.workOrderViewType === CTMWorkOrderViewType.Quotation;
  }

  // ========================================================================
  // CONSTRUCTOR
  // ========================================================================

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private workOrderService: WorkOrderService,
    private managerService: CtManagerService,
    private CTModelService: CtModelService<any>,
    private packagingService: PackagingService,
    private schedulerService: SchedulerService,
    private workOrderDynamicFormService: WorkOrderDynamicFormService,
    private reportController: ReportController,
    private webapiService: CtWebapiService,
    private fileManagementService: CtFileManagementService,
    private dialogService: MatDialog,
  ) {
    this.pId = this.route.snapshot.paramMap.get("id");
  }

  // ========================================================================
  // LIFECYCLE HOOKS
  // ========================================================================

  ngOnInit(): void {
    this.initializeComponent();
  }

  ngAfterViewInit(): void {
    // Gestione query params per tab selection
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(qp => {
        if (qp['rows']) {
          setTimeout(() => this.viewModel.selectedIndex = 1, 200);
        }
      });

    // Assegna header actions al route data
    this.route.data
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        data['headerActions'] = this.headerActions;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // ========================================================================
  // INIZIALIZZAZIONE COMPONENTE
  // ========================================================================

  /**
   * Inizializza il componente in modo strutturato.
   * Separa le fasi di caricamento per maggiore chiarezza e performance.
   */
  private async initializeComponent(): Promise<void> {
    try {
      this.isLoading = true;

      // FASE 1: Carica configurazione base (tipo work order, feature flags)
      await this.loadBaseConfiguration();

      // FASE 2: Inizializza configurazioni sezioni
      this.initializeSectionConfigurations();

      // FASE 3: Carica tutti gli override in parallelo (ottimizzazione performance)
      await this.loadAllOverridesInParallel();

      // FASE 4: Setup specifico per modalità edit
      if (this.pId) {
        await this.loadWorkOrderData();
      }

      // FASE 5: Setup dynamic forms se abilitati
      if (this.workOrderDynamicTabFormConfiguration?.visible) {
        await this.setupDynamicTabForm();
      }

      // FASE 6: Setup route data (breadcrumbs, titolo)
      this.setupRouteData();

    } catch (error) {
      console.error('Errore durante l\'inizializzazione del componente:', error);
    } finally {
      this.isLoading = false;

      // Forza change detection nel prossimo tick per evitare NG0100
      setTimeout(() => this.cdr.detectChanges(), 0);
    }
  }

  /**
   * Carica la configurazione base: tipo work order e feature flags
   */
  private async loadBaseConfiguration(): Promise<void> {
    // Determina il tipo di work order dalla route
    this.viewModel.workOrderViewType = await this.workOrderService.getRouteWorkOrderType(this.route);

    // Carica feature flags in parallelo
    const [extraDataEnabled, calendarEnabled, warehouseEnabled] = await Promise.all([
      this.managerService.hasEnabled.monitoring(),
      this.managerService.hasEnabled.calendar(),
      this.pId ? this.managerService.hasEnabled.warehouse() : Promise.resolve(false)
    ]);

    this.viewModel.workOrderExtraDataEnabled = extraDataEnabled;
    this.viewModel.workOrderCalendarEnabled = calendarEnabled;
    this.viewModel.workOrderRowHandlingEnabled = warehouseEnabled;

    // Setup modalità edit
    if (this.pId) {
      this.viewModel.masterDetail = true;
      this.eventLogButtonConfiguration.setVisible(true);

      // Setup scheduler configuration se calendar è abilitato
      if (calendarEnabled) {
        const param = this.schedulerService.returnParam(+this.pId);
        this.schedulerListConfiguration = new SchedulerListConfiguration(
          [CTModelDatatableFilter.create()
            .setField('Workorder.Oid')
            .setValue(+this.pId)
            .setOperatorType(CtBinaryOperator.Equal)],
          param
        )
          .setAction(() => this.submit(null))
          .setUseModal(true);
      }
    }

    // Setup model configuration
    const routeData: CtModelRouteData = WorkOrderRouteData().setModelType(CtModelType.FORM);
    if (this.pId) {
      routeData.setId(+this.pId);
    }
    this.configuration = CtModelConfiguration
      .create<WorkOrderDefaultEditComponent>()
      .setRouteData(routeData);
  }

  /**
   * Inizializza tutte le configurazioni delle sezioni con i valori di default
   */
  private initializeSectionConfigurations(): void {
    this.generalDataConfiguration = GeneralDataConfiguration
      .create(this.viewModel.workOrderViewType)
      .setWorkOrderOid(this.pId ? +this.pId : null)
      .enableImport(this.viewModel.workOrderRowHandlingEnabled)
      .enableExtraDataJson(this.viewModel.workOrderExtraDataEnabled);

    this.movementManagerConfiguration = MovementManagerConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null)
      .setIsQuotation(this.isQuotation)
      .setEnableWerehouse(this.viewModel.workOrderRowHandlingEnabled);

    this.workOrderHandlingsConfiguration = WorkOrderHandlingsConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null);

    this.workOrderDocumentsConfiguration = WorkOrderDocumentsConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null);

    this.workOrderLocationConfiguration = WorkOrderLocationConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null);

    this.workOrderEditTemplateConfiguration = WorkOrderEditTemplateConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null);

    this.workOrderDynamicTabFormConfiguration = WorkOrderDynamicTabFormConfiguration.create();
    this.workOrderTaskTabConfiguration = CTConfigurationModel.create().setVisible(false);
    // Tab "Fatturazione": nascosto di default, abilitato per-client tramite
    // `getComponentOverride("workOrder", "workOrderPaymentTabConfiguration", ...)`.
    this.workOrderPaymentTabConfiguration = CTConfigurationModel.create().setVisible(false);
    this.workOrderSummaryConfiguration = CTConfigurationModel.create();

    this.creaPackagingButtonConfiguration = CtButtonConfiguration
      .create()
      .setLabel("CreatePackaging")
      .setAction(() => this.createPackaging())
      .setMatherialOptions(MAT_RAISED_PRIMARY)
      .setVisible(false);
  }

  /**
   * Carica tutti gli override delle configurazioni in parallelo.
   * Questo migliora significativamente le performance rispetto a chiamate sequenziali.
   */
  private async loadAllOverridesInParallel(): Promise<void> {
    await Promise.all([
      this.managerService.getComponentOverride("workOrder", "workOrderDownloadConfiguration", this.workOrderDownloadConfiguration),
      this.managerService.getComponentOverride("workOrder", "langDownloadFileConfiguration", this.langDownloadFileConfiguration),
      this.managerService.getComponentOverride("workOrder", "workOrderDownloadMenuConfiguration", this.workOrderDownloadMenuConfiguration),
      this.managerService.getComponentOverride("workOrder", "generalDataConfiguration", this.generalDataConfiguration),
      this.managerService.getComponentOverride("workOrder", "movementManagerConfiguration", this.movementManagerConfiguration),
      this.managerService.getComponentOverride("workOrder", "workOrderSummaryConfiguration", this.workOrderSummaryConfiguration),
      this.managerService.getComponentOverride("workOrder", "workOrderDynamicTabFormConfiguration", this.workOrderDynamicTabFormConfiguration),
      this.managerService.getComponentOverride("workOrder", "workOrderLocationConfiguration", this.workOrderLocationConfiguration),
      this.managerService.getComponentOverride("workOrder", "workOrderEditTemplateConfiguration", this.workOrderEditTemplateConfiguration),
      this.managerService.getComponentOverride("workOrder", "workOrderTaskTabConfiguration", this.workOrderTaskTabConfiguration),
      this.managerService.getComponentOverride("workOrder", "workOrderPaymentTabConfiguration", this.workOrderPaymentTabConfiguration),
      this.managerService.getComponentOverride("workOrder", "createPackaging", this.creaPackagingButtonConfiguration),
    ]);
  }

  /**
   * Carica i dati del work order esistente (solo in modalità edit)
   */
  private async loadWorkOrderData(): Promise<void> {
    if (!this.pId || !this.configuration) return;

    try {
      const response = await lastValueFrom(this.CTModelService.getInfos(this.configuration));

      if (!response?.Result?.DataSource) return;

      this.viewModel.workOrder = CTWorkOrder.create<CtWorkOrderInformationContent>(response.Result.DataSource);

      if (!this.viewModel.workOrder.Oid) return;

      // Carica le righe del work order
      const rows = await this.workOrderService.getRows(this.viewModel.workOrder.Oid).catch(() => []);

      // Inizializza array righe
      this.viewModel.workOrder.Rows = new Array<CTWorkOrderRowUnionType>();
      if (rows?.length) {
        rows.forEach(r => this.viewModel.workOrder?.Rows.push(CTWorkOrderRow.create(r)));
      }

      // Setup componenti figli:
      // È fondamentale awaitare setupReady$ prima di chiamare setup(model).
      // GeneralDataComponent esegue performSetup() (che include syncMissingControls)
      // in un setTimeout — quindi potrebbe non essere ancora terminato quando
      // arriva qui. Senza l'await il patchValue() avverrebbe prima che i controlli
      // dinamici siano stati aggiunti al FormGroup, causando la perdita dei valori.
      if (this.generalDataComponent) {
        await this.generalDataComponent.setupReady$;
        this.generalDataComponent.setup(this.viewModel.workOrder);
      }
      if (this.movementManagerComponent) {
        this.movementManagerComponent.setup(this.viewModel.workOrder);
      }

      // Aggiorna il titolo con i dati del work order
      this.updateRouteTitle();

    } catch (error) {
      console.error('Errore durante il recupero delle informazioni:', error);
    }
  }

  /**
   * Aggiorna il titolo della route con i dati del work order
   */
  private updateRouteTitle(): void {
    if (!this.viewModel.workOrder) return;

    this.route.data
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        const title = this.translate.instant(this.isQuotation ? "QUOTATION" : "SingleWorkOrder");
        const code = this.viewModel.workOrder?.Code ?? "";
        const referenceName = this.viewModel.workOrder?.Company?.ReferenceName ?? "";

        data['title'] = `${title} ${code} - ${referenceName}`;
        data['urls'] = [{ title: this.isQuotation ? 'quotation-form' : 'workorder-form' }];

      });
  }

  /**
   * Setup iniziale dei dati della route (breadcrumbs)
   */
  private setupRouteData(): void {
    // Imposta breadcrumbs solo se non abbiamo già un titolo specifico dal work order
    if (!this.viewModel.workOrder) {
      this.route.data
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          data['title'] = this.isQuotation ? "CT_MENU.quotations" : "CT_MENU.workorder";
          data['urls'] = [{ title: this.isQuotation ? 'quotation-form' : 'workorder-form' }];
        });
    }
  }

  // ========================================================================
  // EVENT HANDLERS
  // ========================================================================

  resetTemplate(event: any): void {
    if (event.tab.textLabel === this.translate.instant('CustomTemplate')) {
      this.editor?.tinyEditor?.setup();
    }
  }

  // ========================================================================
  // SUBMIT E SALVATAGGIO
  // ========================================================================

  submit(acceptQuotationDate: Date | null): void {
    if (!this.configuration || this.generalDataComponent?.formConfiguration?.form?.invalid) return;

    const generalDataValue = this.generalDataComponent?.formConfiguration?.form?.value;
    if (!generalDataValue) {
      console.error('Dati non validi');
      return;
    }

    const workOrder = CTWorkOrder
      .create<CtWorkOrderInformationContent>()
      .setName(generalDataValue.Name)
      .setCompanyOid(generalDataValue.Company.value)
      .setCode(generalDataValue.Code)
      .setStateOid(generalDataValue.State)
      .setStartAt(generalDataValue.StartAt)
      .setExpiredAt(generalDataValue.ExpiredAt)
      .setAddress(generalDataValue.Address?.value ? generalDataValue.Address.label : generalDataValue.Address)
      .setDescription(generalDataValue.Description)
      .setExtraDataJSON(generalDataValue.ExtraDataJSON ?? null)
      .setCommission(generalDataValue.Commission);

    if (generalDataValue.InsertDate) {

      workOrder.setInsertDate(generalDataValue.InsertDate);

    }

    if (this.isQuotation) {
      workOrder.setQuotation(true);

      if (acceptQuotationDate) {
        workOrder.setQuotationAcceptAt(acceptQuotationDate);
        this.openQuotationConfirmDialog(workOrder, acceptQuotationDate);
      } else {
        this.saveWorkOrder(workOrder, acceptQuotationDate);
      }
    } else {
      this.saveWorkOrder(workOrder, acceptQuotationDate);
    }
  }

  private openQuotationConfirmDialog(workOrder: any, acceptQuotationDate: Date): void {
    this.dialogService.open(WorkOrderQuotationDialogComponent, {})
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: WorkOrderQuotationDialogResult) => {
        if (!result || result.Accepted === false) return;
        workOrder.setCreateDocumentPdf(result.CreateDocumentPdf);
        this.saveWorkOrder(workOrder, acceptQuotationDate);
      });
  }

  private saveWorkOrder(workOrder: any, acceptQuotationDate: Date | null): void {
    this.CTModelService
      .putInfos(this.configuration!, workOrder)
      ?.pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: CtWebapiGenericResponse<number | null>) => {
          const commands = ['/', 'work-order'];

          if (response.Result && !isNaN(response.Result)) {
            // Creazione: naviga alla pagina edit del nuovo record
            if (this.isQuotation) commands.push('quotations');
            commands.push('edit', response.Result.toString());
            this.router.navigate(commands);
          } else if (this.pId && this.isQuotation && !!acceptQuotationDate) {
            // Accettazione quotation: naviga alla pagina edit
            commands.push('edit', this.pId);
            this.router.navigate(commands);
          }
          // Update normale: non fare nulla, la pagina resta stabile
        },
        error: (err) => console.error('Errore durante l\'operazione:', err)
      });
  }

  // ========================================================================
  // DOWNLOAD PDF
  // ========================================================================

  downloadPdf(lang: any): void {
    if (!this.viewModel?.workOrder?.Oid) return;

    const parameter: ReportDownloadParameter = ReportDownloadParameter
      .create()
      .setWorkOrderOid(this.viewModel.workOrder.Oid)
      .setTemplateLanguage(lang.code ?? 'it')
      .setRowType(lang.rowType ?? WorkOrderRowsExportTypeVO.All)
      .setDirectDownload(false)
      .setOpenInBrowser(true)
      .setAction('WorkOrderPdf')
      .setLabelDownload(`WorkOrder${this.viewModel.workOrder.Oid}`);

    this.workOrderService.downloadWorkOrderPDF(parameter);
  }

  // ========================================================================
  // PACKAGING
  // ========================================================================

  createPackaging(): void {
    if (!this.pId) return;

    const param = WorkOrderPackagingConfiguration.create();
    param.setWorkOrderOid(+this.pId);
    this.packagingService.openDialogPackaging(param);
  }

  // ========================================================================
  // DYNAMIC FORMS
  // ========================================================================

  async setupDynamicTabForm(): Promise<void> {
    if (!this.pId) return;

    const pid = +this.pId;

    try {
      const response = await lastValueFrom(this.workOrderDynamicFormService.getWorkOrderDynamicForms(5, 'TS'));

      if (!response?.Result?.DataSource) return;

      const forms: Array<CtDynamicFormGeneratorConfiguration> = [];

      for (const [idx, cnfg] of (<Array<any>>response.Result.DataSource).entries()) {
        const dynamicFormConfiguration = CtDynamicFormGeneratorConfiguration
          .create()
          .setFormGeneratorModel(cnfg);

        // Carica dati esistenti per questo form.
        // Nota: usiamo `let` perché la variabile viene riassegnata dopo ogni submit
        // con il record aggiornato (con il nuovo Oid in caso di create). Senza questo
        // aggiornamento la closure manterrebbe il valore iniziale (es. null) e tutti
        // i submit successivi — compreso quello innescato dal Download PDF —
        // andrebbero in create generando duplicati.
        let formExistingData = await this.workOrderDynamicFormService.getFormWorkOrderDataValue(cnfg.Oid, pid);

        // Configura callback di submit
        dynamicFormConfiguration.setOnSubmit(async (filteredValue: any) => {
          // Riassegnamento del riferimento: il prossimo submit vedrà l'Oid aggiornato
          // e la chiamata diventerà un update invece di una nuova create.
          formExistingData = await this.handleDynamicFormSubmit(filteredValue, dynamicFormConfiguration, pid, formExistingData);
        });

        // Configura azioni extra (download PDF/Excel)
        this.configureDynamicFormActions(dynamicFormConfiguration, cnfg.Oid, pid, idx);

        // Popola form con dati esistenti
        if (formExistingData) {
          this.existingData = formExistingData;
          const parsedValue = JSON.parse(formExistingData.Content ?? '{}');
          setTimeout(() => this.setChildFormData(idx, parsedValue), 500);
        }

        forms.push(dynamicFormConfiguration);
      }

      this.workOrderDynamicTabFormConfiguration?.setDynamicForms(forms);

    } catch (error) {
      console.error('Errore durante il setup dei form dinamici:', error);
    }
  }

  private async handleDynamicFormSubmit(
    filteredValue: any,
    config: CtDynamicFormGeneratorConfiguration,
    pid: number,
    existingData: WorkOrderDynamicFormDataParameter | null
  ): Promise<WorkOrderDynamicFormDataParameter | null> {
    try {
      const parameter = this.workOrderDynamicFormService.generateWorkOrderDynamicFormDataParameter({
        value: filteredValue.value,
        formGeneratorOid: config.formGeneratorModel?.Oid ?? -1,
        workOrderOid: pid
      });

      if (existingData?.Oid) {
        parameter.setOid(existingData.Oid);
      }

      const response = await lastValueFrom(this.workOrderDynamicFormService.insertWorkOrderData(parameter));

      // Calcola l'Oid risultante: dalla response (caso create) oppure quello già presente (caso update)
      const updatedOid = response?.Result ?? existingData?.Oid ?? -1;

      // Aggiorna this.existingData (usato da downloadExcel per recuperare WorkOrderDataOid)
      if (!this.existingData) {
        this.existingData = {} as WorkOrderDynamicFormDataParameter;
      }
      (<any>this.existingData)['Oid'] = updatedOid;

      // Restituisce il record aggiornato per permettere alla closure di setOnSubmit
      // di tracciare il nuovo Oid: i submit successivi (es. quello scatenato da
      // Download PDF subito dopo un Salva) andranno in update invece di duplicare.
      const updatedRecord: any = existingData ?? {};
      updatedRecord.Oid = updatedOid;
      return updatedRecord as WorkOrderDynamicFormDataParameter;

    } catch (error) {
      console.error("Errore durante l'inserimento dei dati", error);
      // In caso di errore restituiamo lo stato precedente per non perdere
      // l'eventuale Oid già acquisito in submit precedenti.
      return existingData;
    }
  }

  private configureDynamicFormActions(
    config: CtDynamicFormGeneratorConfiguration,
    templateOid: number,
    pid: number,
    idx: number
  ): void {
    // Clone dei bottoni per evitare conflitti tra form multipli
    const pdfButton = CtButtonConfiguration
      .create()
      .setLabel("Download pdf")
      .setMatherialOptions(MAT_RAISED_PRIMARY)
      .setIcon("download")
      .setAction(() => this.downloadTabPdf(templateOid, pid, idx));

    const extraActions = [pdfButton];

    if (this.workOrderDynamicTabFormConfiguration?.exportExcel) {
      const excelButton = CtButtonConfiguration
        .create()
        .setLabel("Download excel")
        .setMatherialOptions(MAT_RAISED_PRIMARY)
        .setIcon("download")
        .setAction(() => this.downloadExcel(idx));

      extraActions.push(excelButton);
    }

    config.setExtraActions(extraActions);
  }

  private setChildFormData(idx: number, value: any): void {
    const references = this.formGeneratorComponents?.toArray() ?? [];
    const componentRef = references[idx];

    if (componentRef) {
      componentRef.form.patchValue(value);
    }
  }

  async downloadTabPdf(templateOid: number, pid: number, idx: number): Promise<void> {
    const references = this.formGeneratorComponents?.toArray() ?? [];
    const componentRef = references[idx];

    if (componentRef?.submitButton?.action) {
      await this.wrapActionInPromise(componentRef.submitButton.action, null);
    }

    // Attendi il salvataggio prima del download
    setTimeout(async () => {
      const parameter: ReportDownloadParameter = ReportDownloadParameter
        .create()
        .setWorkOrderOid(pid)
        .setDirectDownload(true)
        .setAction('WorkOrderTabPdf')
        .setFormTemplateOid(templateOid)
        .setLabelDownload(`Acuse_${pid}`);

      await lastValueFrom(this.reportController.getAnyPDF(parameter));
    }, 2000);
  }

  async downloadExcel(idx: number): Promise<void> {
    const references = this.formGeneratorComponents?.toArray() ?? [];
    const componentRef = references[idx];

    if (componentRef?.submitButton?.action) {
      await this.wrapActionInPromise(componentRef.submitButton.action, null);
    }

    setTimeout(async () => {
      if (!this.existingData) return;

      const controller = this.configuration?.RouteData?.controller;
      if (!controller) return;

      const request: DataRequest = new DataRequest()
        .setController([controller])
        .setAction(`${this.workOrderDynamicTabFormConfiguration?.actionExcel}`)
        .setBody({ WorkOrderDataOid: this.existingData?.Oid })
        .setMethod(MethodEnum.POST)
        .setResponseType('blob');

      this.webapiService
        .request(request)
        .pipe(takeUntil(this.destroy$))
        .subscribe(blob => {
          this.fileManagementService.downloadBlobFromAPIResult(blob, `Acuse_${this.existingData?.Oid}`);
        });
    }, 2000);
  }

  private wrapActionInPromise(action: (param: any) => void, param: any): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        action(param);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  // ========================================================================
  // EVENT LOG DIALOG
  // ========================================================================

  openEventLogDialog(): void {
    if (!this.pId) {
      console.warn('Impossibile aprire i log eventi: WorkOrder.Oid non disponibile');
      return;
    }

    const dialogData: WorkOrderEventLogDialogData = {
      workOrderOid: +this.pId
    };

    this.dialogService.open(WorkOrderEventLogDialogComponent, {
      width: '90vw',
      maxWidth: '90vw',
      minWidth: '600px',
      height: '80vh',
      data: dialogData,
      disableClose: false,
      autoFocus: false
    });
  }

}

// ========================================================================
// INTERFACES E CLASSI DI SUPPORTO
// ========================================================================

export interface WorkOrderDefaultEditViewModel {
  workOrder: CTWorkOrder<CtWorkOrderInformationContent> | null;
  workOrderViewType: CTMWorkOrderViewType;
  workOrderRowHandlingEnabled: boolean;
  workOrderExtraDataEnabled: boolean;
  workOrderCalendarEnabled: boolean;
  selectedIndex: number;
  masterDetail: boolean;
  offerEnabled: boolean;
}

export class WorkOrderDynamicTabFormConfiguration {
  visible: boolean = true;
  dynamicForms: Array<any> = [];
  exportExcel: boolean = false;
  actionExcel: string = 'ExportExcelWorkOrderDynamicForm';

  public static create = () => new WorkOrderDynamicTabFormConfiguration();

  constructor() { }

  setDynamicForms(value: Array<any>): this {
    this.dynamicForms = value;
    return this;
  }

  setVisible(value: boolean): this {
    this.visible = value;
    return this;
  }

  setExportExcel(value: boolean): this {
    this.exportExcel = value;
    return this;
  }

  setActionExcel(value: string): this {
    this.actionExcel = value;
    return this;
  }
}
